var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,11.2c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S13.3,9.5,13.3,11.2z M12.5,14.5c1.1-0.7,1.8-1.9,1.8-3.3 c0-2.2-1.8-4-4-4s-4,1.8-4,4c0,1.4,0.7,2.6,1.8,3.3c-3.1,1-5.3,3.8-5.3,7.2c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5 c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5C17.8,18.3,15.6,15.5,12.5,14.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.7,5.5c0,0.3-0.2,0.5-0.5,0.5h-3.3v3.3c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5V6h-3.3c-0.3,0-0.5-0.2-0.5-0.5 c0-0.3,0.2-0.5,0.5-0.5h3.3V1.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V5h3.3C21.5,5,21.7,5.3,21.7,5.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitation);
export default __webpack_public_path__ + "static/media/icon-invitation.3016a0ab8cf061dc4355c0589e65e407.svg";
export { ForwardRef as ReactComponent };